import { render, staticRenderFns } from "./runtime.vue?vue&type=template&id=545a5f89&scoped=true&"
import script from "./runtime.vue?vue&type=script&lang=js&"
export * from "./runtime.vue?vue&type=script&lang=js&"
import style0 from "./runtime.vue?vue&type=style&index=0&id=545a5f89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545a5f89",
  null
  
)

export default component.exports